import type { JWTPayload } from 'jose'

import { useJSON } from '@/hooks/core/useJSON'
import { decodeJwt } from 'jose'

/**
 * @description JWT 格式トークンを解析
 * @param token
 * @returns オブジェクト
 */
export const parseJWT = <T>(token: string): T | undefined => {
  try {
    const jwtPayload: JWTPayload = decodeJwt(token)
    return jwtPayload as unknown as T
  } catch (error) {
    console.error('The token format is wrong.')
    return undefined
  }
}

export interface RoleIDList {
  corporateNumber: string
  roleCode: string
}

/**
 * @description トークンから解析したユーザー情報から `企業 ID:ロール ID` を取得
 * @param idList "{\"<企業 ID>\":\"<ロール ID>\"}"
 * @returns
 */
export const parseRoleIDList = (idList: string): RoleIDList => {
  const { parseJSON } = useJSON()
  const roleIDArray: RoleIDList[] = []

  const objectList = parseJSON<{ [property: string]: string }>(idList)

  if (!objectList) {
    const empty: RoleIDList = { corporateNumber: '', roleCode: '' }
    return empty
  }

  Object.keys(objectList).forEach((key) => {
    const item: RoleIDList = { corporateNumber: '', roleCode: '' }
    item.corporateNumber = key
    item.roleCode = objectList[key]
    roleIDArray.push(item)
  })

  return roleIDArray[0]
}
